import React from 'react'
import { FormFieldShell } from './FormFieldShell'
import {
  DateTimeFieldControl,
  type DateTimeFieldControlProps,
} from './dateTime/DateTimeFieldControl'
import type { BaseFormFieldProps } from './formFieldTypes'

export type DateTimeInputProps = BaseFormFieldProps &
  Pick<DateTimeFieldControlProps, 'dateOnly' | 'timeOnly' | 'showIcon' | 'min'> & {
    /** Chuỗi local `YYYY-MM-DDTHH:mm` (24h). */
    value?: string
    onChange?: (event: { target: { value: string; name?: string } }) => void
    name?: string
  }

/**
 * Form field ngày + giờ chuẩn 24h (base: `DateTimeFieldControl`).
 * value/onChange: `YYYY-MM-DDTHH:mm`.
 */
export function DateTimeInput({
  label,
  labelAction,
  value = '',
  name,
  onChange,
  required,
  disabled,
  error,
  helperText,
  size,
  fullWidth,
  sx,
  id,
  surface,
  dateOnly,
  timeOnly,
  showIcon,
  min,
}: DateTimeInputProps) {
  // Ô ngày giờ cố định vừa nội dung — không stretch full hàng trừ khi truyền fullWidth.
  const resolvedFullWidth = fullWidth === true
  const control = (
    <DateTimeFieldControl
      value={value}
      onChange={(next) => onChange?.({ target: { value: next, name } })}
      disabled={disabled}
      required={required}
      error={error}
      fullWidth={resolvedFullWidth}
      id={id}
      surface={surface}
      dateOnly={dateOnly}
      timeOnly={timeOnly}
      showIcon={showIcon}
      min={min}
      sx={!label && !labelAction && !helperText ? sx : undefined}
    />
  )

  if (!label && !labelAction && !helperText) {
    return control
  }

  return (
    <FormFieldShell
      label={label}
      labelAction={labelAction}
      required={required}
      disabled={disabled}
      error={error}
      helperText={helperText}
      fullWidth={resolvedFullWidth}
      size={size}
      sx={sx}
      id={id}
      surface={surface}
    >
      {control}
    </FormFieldShell>
  )
}

export default DateTimeInput
